module.exports = __webpack_public_path__ + "img/product_94.5434f53.webp";